import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Separator } from "../../components/ui/separator";
import React, { useCallback, useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import axios from "axios";
import { useParams } from "react-router-dom";
import { toast, Toaster } from "sonner";
import { Download, Wallet2 } from 'lucide-react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from '../../components/ui/pagination';
const AppliedProviderDetails = () => {
  const token = localStorage.getItem("adminToken");
  const { id } = useParams();
  const [text, setText] = useState("");
  const [agent, setAgent] = useState("");
  const [status, setStatus] = useState("");
  const [partner, setPartner] = useState(null);
  const [ParterWallet, setParterWallet] = useState({});
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [openWalletDialog, setOpenWalletDialog] = useState(false);
  const [walletAmount, setWalletAmount] = useState("");
  const [walletDescription, setWalletDescription] = useState("");
  const [walletAction, setWalletAction] = useState(null);
  const [data, setData] = useState({
    categories: [],
    subcategories: [],
    services: [],
  });
  const [Transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTransaction = Transactions?.slice(indexOfFirstItem, indexOfLastItem);

  // Handle pagination clicks
  const totalPages = Math.ceil(Transactions?.length / itemsPerPage);
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const maxVisiblePages = 5;
  const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  const getPartnerDetails = async () => {
    try {
      const res = await axios.get(
        `https://wavetechservices.in/api/admin/partners/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPartner(res.data.partner);
    } catch (error) {
      console.log(error, "error");
      toast.error("Failed to fetch partner details");
    }
  };

  const getWallet = async () => {
    try {
      if (!id) return;
      const res = await axios.get(
        `https://wavetechservices.in/api/admin/adminwallets/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(res.data.data, "wallet details");

      setParterWallet(res.data.data);
      setTransactions(res.data.data?.transactions?.reverse() || []);
    } catch (error) {
      console.log(error, "error");
      toast.error("Failed to fetch partner wallet details");
    }
  };

  const endpoints = {
    categories: {
      url: "https://wavetechservices.in/api/admin/services/service-categories",
      ids: partner?.category || [],
    },
    subcategories: {
      url: "https://wavetechservices.in/api/user/subcategories",
      ids: partner?.subcategory || [],
    },
    services: {
      url: "https://wavetechservices.in/api/user/services",
      ids: partner?.service || [],
    },
  };

  const fetchData = useCallback(async () => {
    const results = {};

    await Promise.all(
      Object.entries(endpoints).map(async ([key, { url, ids }]) => {
        try {
          const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` },
          });

          results[key] = res.data.data.filter((item) =>
            ids.includes(item._id)
          );
        } catch (error) {
          console.error(`Error fetching ${key}:`, error);
          toast.error(`Failed to fetch ${key}`);
          results[key] = [];
        }
      })
    );

    setData(results);
  }, [token, partner]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    getPartnerDetails();
    getWallet()
  }, []);

  const postPartnerStatus = async () => {
    try {
      const res = await axios.put(
        `https://wavetechservices.in/api/partner/kyc/${id}/status`,
        {
          status,
          remarks: text,
          agent: agent,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.status === 200) {
        toast.success("Status Updated Successfully");
        setOpenStatusDialog(false);
        getPartnerDetails();
      }
    } catch (err) {
      console.error("Error : ", err);
      toast.error("Failed to update status");
    }
  };

  const handleWalletAction = async () => {
    if (!walletAmount || isNaN(walletAmount) || Number(walletAmount) <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }

    try {
      const response = await axios.put(
        `https://wavetechservices.in/api/admin/partner/addwallets`,
        {
          amount: Number(walletAmount),
          description: walletDescription,
          type: walletAction,
          partner: id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        toast.success(`Successfully ${walletAction === 'credit' ? 'added' : 'deducted'} amount`);
        setWalletAmount("");
        setWalletDescription("");
        setWalletAction(null);
        getWallet(); // Refresh partner data to update wallet balance and transactions
      }
    } catch (error) {
      console.error("Error processing wallet action:", error);
      toast.error(error.response?.data?.message || "Operation failed");
    }
  };

  const handleStatusSubmit = () => {
    postPartnerStatus();
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "approved":
        return (
          <div className="inline-flex items-center rounded-full bg-green-500 px-4 py-2 text-xs font-semibold text-white">
            Approved
          </div>
        );
      case "rejected":
        return (
          <div className="inline-flex items-center rounded-full bg-red-500 px-4 py-2 text-xs font-semibold text-white">
            Rejected
          </div>
        );
      case "pending":
        return (
          <div className="inline-flex items-center rounded-full bg-orange-500 px-4 py-2 text-xs font-semibold text-white">
            Pending
          </div>
        );
      default:
        return (
          <div className="inline-flex items-center rounded-full bg-gray-500 px-4 py-2 text-xs font-semibold text-white">
            Unknown
          </div>
        );
    }
  };

  const downloadProviderDetails = async () => {
    if (!partner) return;

    try {
      const content = document.createElement('div');
      content.style.position = 'absolute';
      content.style.left = '-9999px';
      content.style.width = '794px';
      content.style.padding = '20px';
      content.style.backgroundColor = 'white';

      content.innerHTML = `
        <div style="width: 100%; max-width: 800px; margin: 0 auto; font-family: Arial, sans-serif;">
          <div style="text-align: center; margin-bottom: 20px; page-break-after: avoid;">
            <h1 style="font-size: 24px; font-weight: bold; color: #333;">Provider Details</h1>
            <p style="color: #666; font-size: 14px;">ID: ${partner._id}</p>
            <span style="display: inline-block; padding: 4px 12px; border-radius: 12px; font-size: 12px; font-weight: 600; 
              ${partner?.kyc?.status === 'approved' ? 'background: #D1FAE5; color: #065F46;' :
          partner?.kyc?.status === 'rejected' ? 'background: #FEE2E2; color: #991B1B;' :
            'background: #FEF3C7; color: #92400E;'}">
              ${partner?.kyc?.status?.toUpperCase() || 'UNKNOWN'}
            </span>
          </div>
          
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px; page-break-inside: avoid;">
            <div style="background: #F9FAFB; padding: 16px; border-radius: 8px;">
              <h2 style="font-size: 18px; font-weight: 600; color: #333; border-bottom: 1px solid #E5E7EB; padding-bottom: 8px; margin-bottom: 12px;">
                Personal Information
              </h2>
              <div style="display: grid; gap: 8px;">
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Name:</span> ${partner?.profile?.name || 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Email:</span> ${partner?.profile?.email || 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Phone:</span> ${partner?.phone || 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">WhatsApp:</span> ${partner?.whatsappNumber || 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Address:</span> ${partner?.profile?.address || 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Landmark:</span> ${partner?.profile?.landmark || 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Pincode:</span> ${partner?.profile?.pincode || 'N/A'}</p>
              </div>
            </div>
            
            <div style="background: #F9FAFB; padding: 16px; border-radius: 8px;">
              <h2 style="font-size: 18px; font-weight: 600; color: #333; border-bottom: 1px solid #E5E7EB; padding-bottom: 8px; margin-bottom: 12px;">
                Bank Details
              </h2>
              <div style="display: grid; gap: 8px;">
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Account Holder:</span> ${partner?.bankDetails?.accountHolderName || 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Account Number:</span> ${partner?.bankDetails?.accountNumber || 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">IFSC Code:</span> ${partner?.bankDetails?.ifscCode || 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Bank Name:</span> ${partner?.bankDetails?.bankName || 'N/A'}</p>
              </div>
            </div>
          </div>
          
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px; page-break-inside: avoid;">
            <div style="background: #F9FAFB; padding: 16px; border-radius: 8px;">
              <h2 style="font-size: 18px; font-weight: 600; color: #333; border-bottom: 1px solid #E5E7EB; padding-bottom: 8px; margin-bottom: 12px;">
                Experience & Qualification
              </h2>
              <div style="display: grid; gap: 8px;">
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Experience:</span> ${partner?.experience ? `${partner.experience} years` : 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Qualification:</span> ${partner?.qualification || 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Mode of Service:</span> ${partner?.modeOfService || 'N/A'}</p>
              </div>
            </div>
            
            <div style="background: #F9FAFB; padding: 16px; border-radius: 8px;">
              <h2 style="font-size: 18px; font-weight: 600; color: #333; border-bottom: 1px solid #E5E7EB; padding-bottom: 8px; margin-bottom: 12px;">
                Service Details
              </h2>
              <div style="display: grid; gap: 8px;">
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Category:</span> ${partner?.category || 'N/A'}</p>
                <p style="font-size: 14px; margin: 0;"><span style="font-weight: 500; color: #4B5563;">Subcategory:</span> ${partner?.subcategory || 'N/A'}</p>
              </div>
            </div>
          </div>
          
          <div style="background: #F9FAFB; padding: 16px; border-radius: 8px; margin-bottom: 20px; page-break-inside: avoid;">
            <h2 style="font-size: 18px; font-weight: 600; color: #333; border-bottom: 1px solid #E5E7EB; padding-bottom: 8px; margin-bottom: 12px;">
              Documents
            </h2>
            <div style="margin-bottom: 16px; page-break-inside: avoid;">
              <h3 style="font-size: 16px; font-weight: 500; color: #4B5563; margin-bottom: 8px;">Aadhaar Card</h3>
              <img src="${partner?.kyc?.aadhaar}" style="max-width: 100%; max-height: 200px; border: 1px solid #E5E7EB;"/>
            </div>
            <div style="margin-bottom: 16px; page-break-inside: avoid;">
              <h3 style="font-size: 16px; font-weight: 500; color: #4B5563; margin-bottom: 8px;">PAN Card</h3>
              <img src="${partner?.kyc?.panCard}" style="max-width: 100%; max-height: 200px; border: 1px solid #E5E7EB;"/>
            </div>
            <div style="margin-bottom: 16px; page-break-inside: avoid;">
              <h3 style="font-size: 16px; font-weight: 500; color: #4B5563; margin-bottom: 8px;">Cancelled Cheque</h3>
              <img src="${partner?.kyc?.chequeImage}" style="max-width: 100%; max-height: 200px; border: 1px solid #E5E7EB;"/>
            </div>
            <div style="margin-bottom: 16px; page-break-inside: avoid;">
              <h3 style="font-size: 16px; font-weight: 500; color: #4B5563; margin-bottom: 8px;">Driving Licence</h3>
              <img src="${partner?.kyc?.drivingLicence}" style="max-width: 100%; max-height: 200px; border: 1px solid #E5E7EB;"/>
            </div>
            <div style="margin-bottom: 16px; page-break-inside: avoid;">
              <h3 style="font-size: 16px; font-weight: 500; color: #4B5563; margin-bottom: 8px;">Bill</h3>
              <img src="${partner?.kyc?.bill}" style="max-width: 100%; max-height: 200px; border: 1px solid #E5E7EB;"/>
            </div>
            <div style="page-break-inside: avoid;">
              <h3 style="font-size: 16px; font-weight: 500; color: #4B5563; margin-bottom: 8px;">Profile Picture</h3>
              <img src="${partner?.profilePicture}" style="max-width: 100%; max-height: 200px; border: 1px solid #E5E7EB; border-radius: 50%;"/>
            </div>
          </div>
          
          <div style="text-align: center; color: #6B7280; font-size: 12px; page-break-before: avoid;">
            Generated on ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}
          </div>
        </div>
      `;

      document.body.appendChild(content);

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageHeight = pdf.internal.pageSize.getHeight();
      const pageWidth = pdf.internal.pageSize.getWidth();

      const canvas = await html2canvas(content, {
        scale: 2,
        logging: false,
        useCORS: true,
      });

      const imgData = canvas.toDataURL('image/png');
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;
      const imgMargin = 10;

      pdf.addImage(imgData, 'PNG', imgMargin, position, imgWidth - (imgMargin * 2), imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', imgMargin, position, imgWidth - (imgMargin * 2), imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`provider_details_${partner._id}.pdf`);
      document.body.removeChild(content);

      toast.success("PDF download started");
    } catch (error) {
      console.error("Error downloading details:", error);
      toast.error("Failed to generate PDF");
    }
  };

  if (!partner) {
     return<div className="flex items-center justify-center h-screen">
           <button
  disabled=""
  class="bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold py-3 px-6 rounded-full shadow-lg flex items-center transition duration-300 transform hover:scale-105 active:scale-95"
>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="animate-spin h-5 w-5 mr-3 text-white"
  >
    <circle
      stroke-width="4"
      stroke="currentColor"
      r="10"
      cy="12"
      cx="12"
      class="opacity-25"
    ></circle>
    <path
      d="M4 12a8 8 0 018-8v8H4z"
      fill="currentColor"
      class="opacity-75"
    ></path>
  </svg>
  Loading...
</button>
    </div>
  }

  return (
    <div className="px-4 py-6 max-w-7xl mx-auto">
      <Toaster />
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-800">
            Provider Verification
          </h1>
          <p className="text-gray-600">ID: {partner._id}</p>
        </div>
        <div className="flex items-center gap-4">
          <Dialog open={openWalletDialog} onOpenChange={setOpenWalletDialog}>
            <DialogTrigger asChild>
              <Button variant="outline" className="flex items-center gap-2">
                <Wallet2 className="h-4 w-4" />
                Wallet
              </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-[600px]">
              <DialogHeader>
                <DialogTitle>Wallet Management - {partner?.profile?.name}</DialogTitle>
                <DialogDescription>
                  Manage wallet balance and view transaction history
                </DialogDescription>
              </DialogHeader>
              <div className="grid gap-4 py-4">
                <div className="bg-gray-100 p-4 rounded-md">
                  <h3 className="text-lg font-semibold">Current Balance: ₹{ParterWallet?.balance || 0}</h3>
                </div>
                <div className="grid grid-cols-1 gap-4">
                  <div className="grid grid-cols-4 items-center gap-4">
                    <Label htmlFor="wallet-amount" className="text-right">Amount</Label>
                    <Input
                      id="wallet-amount"
                      type="number"
                      value={walletAmount}
                      onChange={(e) => setWalletAmount(e.target.value)}
                      className="col-span-3"
                      placeholder="Enter amount"
                    />
                  </div>
                  <div className="grid grid-cols-4 items-center gap-4">
                    <Label htmlFor="wallet-description" className="text-right">Description</Label>
                    <Input
                      id="wallet-description"
                      value={walletDescription}
                      onChange={(e) => setWalletDescription(e.target.value)}
                      className="col-span-3"
                      placeholder="Enter description"
                    />
                  </div>
                  <div className="flex gap-2">
                    <Button
                      onClick={() => setWalletAction('credit')}
                      disabled={!walletAmount || !walletDescription}
                    >
                      Add Amount
                    </Button>
                    <Button
                      onClick={() => setWalletAction('debit')}
                      disabled={!walletAmount || !walletDescription}
                      variant="destructive"
                    >
                      Deduct Amount
                    </Button>
                  </div>
                </div>
                <Separator />
                <h3 className="text-lg font-semibold">Transaction History</h3>
                <div className="overflow-x-auto">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Transaction ID</TableHead>
                        <TableHead>Type</TableHead>
                        <TableHead>Amount</TableHead>
                        <TableHead>Balance</TableHead>
                        <TableHead>Description</TableHead>
                        <TableHead>Date</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {currentTransaction?.length > 0 ? (
                        currentTransaction.map((txn) => (
                          <TableRow key={txn.transactionId}>
                            <TableCell>{txn.transactionId}</TableCell>
                            <TableCell className={txn.type === 'credit' ? 'text-green-600' : 'text-red-600'}>
                              {txn.type.charAt(0).toUpperCase() + txn.type.slice(1)}
                            </TableCell>
                            <TableCell>₹{txn.amount}</TableCell>
                            <TableCell>₹{txn.balance}</TableCell>
                            <TableCell>{txn.description || '-'}</TableCell>
                            <TableCell>{new Date(txn.createdAt).toLocaleString()}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={6} className="text-center py-4">
                            No transactions found
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </div>
                <Pagination className="mt-4">
                  <PaginationContent>
                    {currentPage > 1 && (
                      <PaginationItem>
                        <PaginationPrevious onClick={() => handlePageChange(currentPage - 1)} />
                      </PaginationItem>
                    )}

                    {startPage > 1 && (
                      <>
                        <PaginationItem>
                          <PaginationLink onClick={() => handlePageChange(1)}>1</PaginationLink>
                        </PaginationItem>
                        {startPage > 2 && <PaginationItem><span>...</span></PaginationItem>}
                      </>
                    )}

                    {[...Array(endPage - startPage + 1)].map((_, index) => {
                      const pageNumber = startPage + index;
                      return (
                        <PaginationItem key={pageNumber}>
                          <PaginationLink
                            isActive={pageNumber === currentPage}
                            onClick={() => handlePageChange(pageNumber)}
                          >
                            {pageNumber}
                          </PaginationLink>
                        </PaginationItem>
                      );
                    })}

                    {endPage < totalPages && (
                      <>
                        {endPage < totalPages - 1 && <PaginationItem><span>...</span></PaginationItem>}
                        <PaginationItem>
                          <PaginationLink onClick={() => handlePageChange(totalPages)}>{totalPages}</PaginationLink>
                        </PaginationItem>
                      </>
                    )}

                    {currentPage < totalPages && (
                      <PaginationItem>
                        <PaginationNext onClick={() => handlePageChange(currentPage + 1)} />
                      </PaginationItem>
                    )}
                  </PaginationContent>
                </Pagination>
              </div>
              {walletAction && (
                <div className="flex justify-end gap-2">
                  <Button variant="outline" onClick={() => setWalletAction(null)}>
                    Cancel
                  </Button>
                  <Button onClick={handleWalletAction}>
                    Confirm {walletAction === 'credit' ? 'Add' : 'Deduct'}
                  </Button>
                </div>
              )}
            </DialogContent>
          </Dialog>
          <Button
            variant="outline"
            onClick={downloadProviderDetails}
            className="flex items-center gap-2"
          >
            <Download className="h-4 w-4" />
            Download Details
          </Button>
          <span className="text-sm font-medium text-gray-600">Current Status:</span>
          {getStatusBadge(partner?.kyc?.status)}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Card className="lg:col-span-1">
          <CardHeader>
            <CardTitle className="flex items-center gap-4">
              <div className="h-16 w-16 rounded-full overflow-hidden">
                <img
                  src={`${partner?.profilePicture}`}
                  alt="Profile"
                  className="h-full w-full object-cover"
                />
              </div>
              <div>
                <h2 className="text-xl font-semibold">
                  {partner?.profile?.name}
                </h2>
                <p className="text-sm text-gray-500">{partner?.profile?.email}</p>
              </div>
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-medium text-gray-500">Phone</h3>
                <p className="text-base">{partner?.phone}</p>
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-500">Address</h3>
                <p className="text-base">{partner?.profile?.address}</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="lg:col-span-2">
          <CardHeader>
            <CardTitle>Documents Verification</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <DocumentCard
                title="Aadhaar Card"
                imageUrl={`${partner?.kyc?.aadhaar}`}
              />
              <DocumentCard
                title="PAN Card"
                imageUrl={`${partner?.kyc?.panCard}`}
              />
              <DocumentCard
                title="Cancelled Cheque / PassBook Front Page"
                imageUrl={`${partner?.kyc?.chequeImage}`}
              />
              <DocumentCard
                title="Driving Licence / Voter Id"
                imageUrl={`${partner?.kyc?.drivingLicence}`}
              />
              <DocumentCard
                title="Water / Electricity Bill"
                imageUrl={`${partner?.kyc?.bill}`}
              />
            </div>
          </CardContent>
        </Card>

        <Card className="lg:col-span-1">
          <CardHeader>
            <CardTitle>Bank Details</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="text-sm font-medium text-gray-500">
                  Account Holder
                </h3>
                <p className="text-base">
                  {partner?.bankDetails?.accountHolderName}
                </p>
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-500">
                  Account Number
                </h3>
                <p className="text-base">
                  {partner?.bankDetails?.accountNumber}
                </p>
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-500">IFSC Code</h3>
                <p className="text-base">{partner?.bankDetails?.ifscCode}</p>
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-500">Bank Name</h3>
                <p className="text-base">{partner?.bankDetails?.bankName}</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="lg:col-span-1">
          <CardHeader>
            <CardTitle>Service Information</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-6">
              <div>
                <h3 className="text-sm font-medium text-gray-500 mb-2">Categories</h3>
                <div className="flex flex-wrap gap-2">
                  {data.categories.length > 0 ? (
                    data.categories.map((c) => (
                      <span
                        key={c._id}
                        className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10"
                      >
                        {c.name}
                      </span>
                    ))
                  ) : (
                    <p className="text-sm text-gray-400">No categories selected</p>
                  )}
                </div>
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-500 mb-2">Subcategories</h3>
                <div className="flex flex-wrap gap-2">
                  {data.subcategories.length > 0 ? (
                    data.subcategories.map((s) => (
                      <span
                        key={s._id}
                        className="inline-flex items-center rounded-md bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10"
                      >
                        {s.name}
                      </span>
                    ))
                  ) : (
                    <p className="text-sm text-gray-400">No subcategories selected</p>
                  )}
                </div>
              </div>
              <div>
                <h3 className="text-sm font-medium text-gray-500 mb-2">Services</h3>
                <div className="flex flex-wrap gap-2">
                  {data.services.length > 0 ? (
                    data.services.map((s) => (
                      <span
                        key={s._id}
                        className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-700/10"
                      >
                        {s.name}
                      </span>
                    ))
                  ) : (
                    <p className="text-sm text-gray-400">No services selected</p>
                  )}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Verification Action</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-medium text-gray-500">
                  Current Status
                </h3>
                <div className="mt-1">{getStatusBadge(partner?.kyc?.status)}</div>
              </div>
              <Separator className="my-4" />
              <Dialog open={openStatusDialog} onOpenChange={setOpenStatusDialog}>
                <DialogTrigger asChild>
                  <Button className="w-full">Update Verification Status</Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-[425px]">
                  <DialogHeader>
                    <DialogTitle>Update Verification Status</DialogTitle>
                    <DialogDescription>
                      Change the verification status for this provider
                    </DialogDescription>
                  </DialogHeader>
                  <div className="grid gap-4 py-4">
                    <div className="grid grid-cols-4 items-center gap-4">
                      <label htmlFor="status" className="text-right">
                        Status
                      </label>
                      <select
                        id="status"
                        className="col-span-3 border p-2 rounded"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value="">Select Status</option>
                        <option value="approved">Approved</option>
                        <option value="rejected">Rejected</option>
                      </select>
                    </div>
                    <div className="grid grid-cols-4 items-center gap-4">
                      <label htmlFor="remarks" className="text-right">
                        Remarks
                      </label>
                      <textarea
                        id="remarks"
                        className="col-span-3 border p-2 rounded"
                        rows={3}
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                      />
                    </div>
                    <div className="grid grid-cols-4 items-center gap-4">
                      <label htmlFor="agent" className="text-right">
                        Agent Name
                      </label>
                      <input
                        id="agent"
                        className="col-span-3 border p-2 rounded"
                        value={agent}
                        onChange={(e) => setAgent(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="flex justify-end gap-2">
                    <Button
                      variant="outline"
                      onClick={() => setOpenStatusDialog(false)}
                    >
                      Cancel
                    </Button>
                    <Button onClick={handleStatusSubmit}>Save Changes</Button>
                  </div>
                </DialogContent>
              </Dialog>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

const DocumentCard = ({ title, imageUrl }) => {
  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="p-4 bg-gray-50 border-b">
        <h3 className="font-medium">{title}</h3>
      </div>
      <div className="p-4">
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="outline" className="w-full">
              View Document
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-4xl">
            <DialogHeader>
              <DialogTitle>{title}</DialogTitle>
            </DialogHeader>
            <div className="flex justify-center">
              <img
                src={imageUrl}
                alt={title}
                className="max-h-[70vh] object-contain"
              />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default AppliedProviderDetails;